import React, { useState } from "react";
import Modal from "react-modal";
import { Link } from "react-router-dom";
import "./DrawTCPopup.css";

Modal.setAppElement("#root");

const DrawTCPopup = ({
  isOpen,
  onClose,
  onAccept,
  drawName = "",
  buyInAmount = 0,
  isLoading = false,
}) => {
  const [isAccepted, setIsAccepted] = useState(false);

  const handleAccept = () => {
    if (isAccepted) {
      onAccept();
    }
  };

  const handleClose = () => {
    setIsAccepted(false);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      className="draw-tc-modal"
      overlayClassName="draw-tc-overlay"
      closeTimeoutMS={300}
    >
      <div className="draw-tc-content">
        <button className="close-btn" onClick={handleClose}>
          <i className="fas fa-times"></i>
        </button>

        <div className="draw-tc-header">
          <div className="draw-tc-icon">
            <i className="fas fa-ticket-alt"></i>
          </div>
          <h3>Enter Draw</h3>
          <p className="draw-name">{drawName}</p>
        </div>

        <div className="draw-tc-summary">
          <div className="summary-item">
            <span className="summary-label">Entry Fee</span>
            <span className="summary-value">
              <i className="fas fa-coins"></i> {buyInAmount} Coins
            </span>
          </div>
        </div>

        <div className="tc-section">
          <div className="tc-section-header">
            <h4>
              <i className="fas fa-file-contract"></i> Terms & Conditions
            </h4>
            <Link
              to="/user-agreement"
              target="_blank"
              rel="noopener noreferrer"
              className="read-full-terms"
            >
              Read full terms <i className="fas fa-external-link-alt"></i>
            </Link>
          </div>
          <div className="tc-content-box">
            <ul>
              <li>Entry fee is non-refundable once submitted.</li>
              <li>One entry per user per draw is allowed.</li>
              <li>Winners will be selected randomly through a fair draw system.</li>
              <li>Winners will be notified via email and shown on the winner list.</li>
              <li>Prizes must be claimed within 30 days of announcement.</li>
              <li>Dream Prize reserves the right to disqualify entries for any violations.</li>
              <li>By participating, you agree to allow your name to be displayed if you win.</li>
            </ul>
          </div>
        </div>

        <div className="tc-checkbox-section">
          <label className={`tc-checkbox ${isAccepted ? "checked" : ""}`}>
            <input
              type="checkbox"
              checked={isAccepted}
              onChange={(e) => setIsAccepted(e.target.checked)}
            />
            <span className="checkmark"></span>
            <span className="checkbox-text">
              I have read and agree to the Terms & Conditions
            </span>
          </label>
        </div>

        <div className="tc-action-buttons">
          <button className="cancel-tc-btn" onClick={handleClose}>
            Cancel
          </button>
          <button
            className="confirm-tc-btn"
            onClick={handleAccept}
            disabled={!isAccepted || isLoading}
          >
            {isLoading ? (
              <>
                <i className="fas fa-spinner fa-spin"></i> Processing...
              </>
            ) : (
              <>
                <i className="fas fa-check"></i> Confirm Entry
              </>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DrawTCPopup;
